module.exports = __webpack_public_path__ + "static/img/xy20c.7dfec88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xy20c.jpg
// module id = Do15
// module chunks = 1